module.exports = __webpack_public_path__ + "img/mushroom_cloud_thumb.a1dd4a05.jpg";